import { Component, OnInit } from '@angular/core';
import {IonButton, IonCol, IonRow} from '@ionic/angular/standalone';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-b2b-section',
  templateUrl: './b2b-section.component.html',
  styleUrls: ['./b2b-section.component.scss'],
  imports: [
    IonButton,
    IonCol,
    IonRow,
    RouterLink,
    TranslateModule
  ]
})
export class B2bSectionComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
